module.exports = __webpack_public_path__ + "static/intro-030d22f53fdfcd5c74677f73d69086d4.mp4";